import { DownloadOption } from "@/entry/server/movie";
import { videoRepo } from "@/repo/video-repo";
import { Link } from "react-router-dom";
import React, { useContext, useState } from "react";
import { useEffect } from "react";
import { ConvertDownloadTypeToTitle, FormatSize } from "@/utils/movies_helper";
import { AppContextType, WonmovContext } from "@/context/app-context";
import "@/styles/download-box.css";

type MovieDownloadItem = {
    quality: string;
    quality_code: number;
    encoder: string;
    url: string;
    type: string;
    size: string;
    is_x265: boolean;
    is_10bit: boolean;
    can_play_online: boolean;
}

type MovieDownloadGroup = {
    title: string;
    items: MovieDownloadItem[];
}

export default function MovieDlBox({id}: {id: number}) {
    const {vipData, isLoggedIn} = useContext<AppContextType>(WonmovContext);
    const [downloadGroups, setDownloadGroups] = useState<MovieDownloadGroup[]>([]);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(function () {
        getDownloadOptions();
    }, [id]);

    async function getDownloadOptions() {
        const response = await videoRepo.getDownloadOptions(id);
        if (response.status) {
            setDownloadGroups(GroupDownloadOptions({downloadOptions: response.data!}));
        }
        setIsLoading(false)
    }

    const isVIPUser = isLoggedIn && vipData !== null && vipData.days_left > 0;

    const panelClassName = isLoading
        ? "dlbox__panel dlbox__panel--loading shimmer"
        : "dlbox__panel";

    return (
        <div className="dlbox" id="download-box">
            <h2 className="movie-detail-section-title">باکس دانلود</h2>
            <div className={panelClassName}>
                {downloadGroups.map(function (group, groupIndex) {
                    return (
                        <div key={"group-" + groupIndex} className="dlbox__group">
                            <div className="dlbox__group-header">
                                <span className="dlbox__group-badge">{group.title}</span>
                                <span className="dlbox__group-line" />
                            </div>
                            <div className="dlbox__rows">
                                {group.items.map(function (item, itemIndex) {
                                    return (
                                        <div key={itemIndex} className="dlbox__row">
                                            <div className="dlbox__row-table">
                                                <div className="dlbox__row-meta">
                                                    <span className="dlbox__row-meta-label">کیفیت: </span>
                                                    <span className="dlbox__row-meta-value dlbox__row-meta-value--quality">{item.quality}</span>
                                                </div>
                                                <div className="dlbox__row-meta">
                                                    <span className="dlbox__row-meta-label">انکودر: </span>
                                                    <span className="dlbox__row-meta-value">{item.encoder}</span>
                                                </div>
                                                <div className="dlbox__row-meta">
                                                    <span className="dlbox__row-meta-label">حجم: </span>
                                                    <span className="dlbox__row-meta-value">{item.size}</span>
                                                </div>
                                                <div className="dlbox__row-actions">
                                                    {isVIPUser ? (
                                                        <>
                                                            <a href={item.url} target="_blank" className="dlbox__btn">دانلود مستقیم</a>
                                                            {item.can_play_online ? (
                                                                <Link to={"/player/" + id + "?quality=" + item.quality + "&type=" + item.type} className="dlbox__btn">پخش آنلاین</Link>
                                                            ) : null}
                                                        </>
                                                    ) : (
                                                        isLoggedIn ? (
                                                            <Link to="/profile/subscription" target="_blank" className="dlbox__btn dlbox__btn--auth">تمدید اشتراک</Link>
                                                        ) : (
                                                            <Link to="/auth" className="dlbox__btn dlbox__btn--auth">ورود و ثبت نام</Link>
                                                        )
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>
    )
}

function GroupDownloadOptions({downloadOptions}: {downloadOptions: DownloadOption[]}): MovieDownloadGroup[] {
    const groups: MovieDownloadGroup[] = [];
    downloadOptions.forEach(function (option) {
        const groupTitle = ConvertDownloadTypeToTitle(option.type);
        const encoder = option.encoder === "unknown" ? "نامشخص" : option.encoder;

        let group = groups.find(function (g) {
            return g.title === groupTitle;
        });
        if (!group) {
            group = { title: groupTitle, items: [] };
            groups.push(group);
        }

        const exists = group.items.some(function (item) {
            return item.quality === option.quality && item.encoder === encoder;
        });
        if (exists) return;

        group.items.push({
            quality: option.quality,
            quality_code: parseInt(option.quality_code.split("p")[0], 10) || 0,
            encoder,
            url: option.url,
            type: option.type,
            size: FormatSize(option.size),
            is_x265: option.is_x265,
            is_10bit: option.is_10bit,
            can_play_online: option.can_play_online,
        });
    });

    groups.forEach(function (group) {
        group.items.sort(compareMovieDownloadItem);
    });

    return groups;
}

function compareMovieDownloadItem(a: MovieDownloadItem, b: MovieDownloadItem) {
    if (a.quality_code > b.quality_code) return -1;
    if (a.quality_code < b.quality_code) return 1;
    return a.encoder.localeCompare(b.encoder, "fa");
}
